import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { InvoiceListTypeCell } from './invoice-list-type.cell';
import { InvoiceListTypeHeader } from './invoice-list-type.header';

export const InvoiceListTypeColumn: IdentifiedColumnDef<
  InvoiceModel,
  InvoiceModel['type']
> = {
  enableSorting: false,
  header: InvoiceListTypeHeader,
  cell: InvoiceListTypeCell,
  meta: { width: '200px' },
};
